import { put, takeEvery, takeLatest, call, select, debounce, cancel, fork, delay, all } from 'redux-saga/effects';
import {
	FETCH_PAYMENT_METHODS,
	LINK_PAYMENT_METHOD,
	LINK_PAYMENT_SEND_OTP,
	MAKE_PAYMENT,
	CAPTURE_PAYMENT,
	FETCH_PENDING_BALANCE,
	// PAYTM_ADD_MONEY_RES
	NEUU_WALLET_MAKE_PAYMENT,
	DEBOUNCE_FETCH_PAYMENT_METHODS,
	POOL_PAYMENT_STATUS,
	UPI_COLLECT_PAYMENT,
	CLEAR_UPI_VPA,
	ADD_MONEY_PG,
} from '../actions/types';
import {
	fetchPaymentMethodSuccess,
	fetchPaymentMethodError,
	linkPaymentSendOTPSuccess,
	linkPaymentSuccess,
	selectPayment,
	paymentSuccess,
	paymentError,
	fetchPendingBalanceSuccess,
	fetchPendingBalanceError,
	poolPaymentStatus,
	setSelectedPaymentError,
	resetVerification,
	makePayment as makePaymentAction,
	clearVpaSuccess,
	clearVpaError,
	showPaymentGateway,
	// pgAddMoney as pgAddMoneyAction
} from '../actions/payment';
import {
	getCartPaymentMethods,
	linkPaymentSendOTP as linkPaymentSendOTPAPI,
	linkPaymentMethod as linkPaymentMethodAPI,
	makePayment as makePaymentAPI,
	initRazorPayPayment as initRazorPayPaymentAPI,
	capturePayment as capturePaymentAPI,
	fetchPendingBalance as fetchPendingBalanceAPI,
	getWalletPaymentMethods,
	neuuWalletPayment as neuuWalletPaymentAPI,
	checkPaymentStatus as checkPaymentStatusAPI,
	validateVpa as validateVpaAPI,
	clearVpa as clearVpaAPI,
	pgAddMoney as pgAddMoneyAPI,
} from '../services/payment';
import { showErrorMsg, showSuccessMsg } from '../actions/snackbar';
import { setCartOrderId, resetCart } from '../actions/cart';
import { processPaytmAddMoney } from '../services/payment';
import { setPendingOrders, setAllLiveOrders } from '../actions/orders';
import { validateSession } from './session';
import { deleteCookie } from '../utils';
import { firebase } from '../context/firebase';
import { loadWalletSuccess, loadWalletError } from '../actions/wallet';

function* fetchPaymentMethods(action) {
	try {
		const { payload = {} } = action;
		const { sessionId } = yield select((state) => state.auth || {});
		const { type = 'CART', deliveryFee = 0 } = payload;
		let res = null;
		let amount = 0;
		if (type === 'CART') {
			amount = payload.invoiceAmount;
			res = yield call(validateSession, getCartPaymentMethods, { ...payload, cart: payload.order }, sessionId);
		} else {
			amount = payload.order.amount;
			res = yield call(
				validateSession,
				getWalletPaymentMethods,
				{ ...payload, amount: payload.order.amount, sessionId },
				sessionId
			);
		}

		const { orderId, paymentMethods } = res;
		yield put(fetchPaymentMethodSuccess({ orderId, paymentMethods, amount, deliveryFee }));
		type === 'CART' && (yield put(setCartOrderId(orderId)));
	} catch (error) {
		yield put(fetchPaymentMethodError(error));
		yield put(showErrorMsg(error.message));
	}
}

function* linkPaymentSendOTP(action) {
	try {
		const { sessionId } = yield select((state) => state.auth || {});
		const data = yield call(validateSession, linkPaymentSendOTPAPI, action.payload, sessionId);
		const { paymentMethod } = action.payload;
		yield put(
			linkPaymentSendOTPSuccess({
				paymentMethod,
				type: 'repeat',
				state: data.state,
			})
		);
		// yield put(selectPayment(paymentMethod));
		yield put(showSuccessMsg('OTP sent successfully'));
	} catch (error) {
		yield put(showErrorMsg(error.message));
	}
}

function* linkPaymentMethod(action) {
	try {
		const { sessionId } = yield select((state) => state.auth || {});
		const res = yield call(validateSession, linkPaymentMethodAPI, action.payload, sessionId);
		const { paymentMethod } = action.payload;
		const updatedPayMethod = {
			...paymentMethod,
			...res,
			type: 'repeat',
			openLinkContainer: false,
		};
		yield put(linkPaymentSuccess(updatedPayMethod));
		yield put(selectPayment(updatedPayMethod));
		firebase.analytics().logEvent('linked_wallet', { wallet_type: paymentMethod.id });
	} catch (error) {
		yield put(showErrorMsg(error.message));
	}
}

function* makePayment(action) {
	try {
		const { sessionId } = yield select((state) => state.auth || {});
		const { paymentMethod, amount } = action.payload;
		const res = yield call(validateSession, makePaymentAPI, action.payload, sessionId);
		if (paymentMethod.paymentType === 'cards') {
			return (window.location.href = res.url);
		}

		//console.log("### makePayment saga, payload+response...");
		//console.log(action.payload);
		//console.log (res);

		if ((paymentMethod.name === 'razor_pay') && (!res.status || !res.pg_data)) {
			if(firebase) {
				firebase.analytics().logEvent('payment_failure', { payment_type: paymentMethod.name , amount });
			}

			//FIXME: Use some std error code mechanism...
			let err_code = 6001;
			if (!res.pg_data) err_code = 6002;

			throw new Error(err_code+': Error while processing payment');
		}
		
		//FIXME: S+V:: Move to server...
		if (paymentMethod.name === 'razor_pay') {
			/*
			const rp_res = yield call(validateSession, initRazorPayPaymentAPI, action.payload, sessionId);

			//console.log(rp_res);
			if (!rp_res.status) {
				throw new Error('Error while processing payment');
			} else {
				yield put(showPaymentGateway({...rp_res, pg_data: res.pg_data}));
				return;
			}
			*/
			yield put(showPaymentGateway(res));
			return;
		}

		if ((paymentMethod.name === 'PayTM_WALLET' || paymentMethod.name === 'Ola') && !res.status) {
			if(firebase) {
				firebase.analytics().logEvent('payment_failure', { payment_type: paymentMethod.name , amount });
				paymentMethod.name === 'PayTM_WALLET' && firebase.analytics().logEvent('paytm_load_money_initiated', { amount });					
			}

			const { data } = res;
			if (!data) {
				throw new Error('Error while processing payment');
			}

			const newPaymentMethod = {
				...paymentMethod,
				data,
			}

			if (paymentMethod.name === 'Ola') {
				const { form, url = '' } = res.data;
				if (!form || !url) {
					throw new Error('Error while processing payment');
				}
				newPaymentMethod.data = {
					...newPaymentMethod.data,
					data: form,
				}
			}

			return processPaytmAddMoney(newPaymentMethod.data);
		}

		const { saveVpa = true } = paymentMethod;
		if (paymentMethod.name === 'payu_collect' || (paymentMethod.name === 'upi' && res.url && res.status)) {
			return yield put(
				poolPaymentStatus({
					reqPayload: {
						...action.payload,
						txn_id: res.txn_id,
						vpa: saveVpa,
					},
					upiUrl: res.url,
				})
			);
		}

		const { order = {} } = res;
		yield put(setPendingOrders([order]));
		yield put(setAllLiveOrders(Object.values(order)));
		yield put(paymentSuccess(res));
		yield put(resetCart());
		deleteCookie('cart');
	} catch (error) {
		// console.log(error);
		yield put(showErrorMsg(error.message, 20000));
		yield put(paymentError(error));
	}
}

function* capturePayment(action) {
	const { orderId } = action.payload;//FIXME: remove orderId
	try {
		//console.log ("### In sagas:capturePayment::");
		//console.log (action)
		const { sessionId } = yield select((state) => state.auth || {});
		const res = yield call(validateSession, capturePaymentAPI, action.payload, sessionId);
		const { paymentMethod } = action.payload;
		if (paymentMethod.paymentType === 'cards' && paymentMethod.status !== 'CHARGED') {
			return;
		}
		
		//FIXME: Hack: Move to wallet. Use CAPTURE_WALLET_PAYMENT action...
		if (orderId.startsWith("TM") || orderId.startsWith("NU")) {
			const { order = {} } = res;
			yield put(setPendingOrders([order]));
			yield put(paymentSuccess(res));
			yield put(setAllLiveOrders(Object.values(order)));
			yield put(resetCart());
			deleteCookie('cart');
		} else {
			yield put(loadWalletSuccess(res));
			yield put(showSuccessMsg('Wallet loaded successfully', 4000));
		}
	} catch (error) {
		// console.log(error);
		//FIXME: Hack: Move to wallet. Use CAPTURE_WALLET_PAYMENT action...
		if (orderId.startsWith("TM") || orderId.startsWith("NU")) {
			yield put(paymentError(error, 60000));
			yield put(showErrorMsg(error.message));
		} else {
			yield put(loadWalletError(error));
			yield put(showErrorMsg(error.message));
		}
	}
}

// function* processPaytmAddMoneyRes(action) {
//   try {
//     const res = yield call(processPaytmAddMoneyResAPI, action.payload);
//     // const res = yield new Promise(res => setTimeout(() => res('data'), 10000))
//     console.log(res);
//     yield put(paymentSuccess({res}));
//   } catch (error) {
//     yield put(paymentError(error));
//   }
// }

function* fetchPendingBalance(action) {
	try {
		const { sessionId } = yield select((state) => state.auth || {});
		let amount = +(yield call(validateSession, fetchPendingBalanceAPI, action.payload, sessionId));
		amount = amount <= 0 ? 0 : amount;
		yield put(fetchPendingBalanceSuccess(amount));
	} catch (error) {
		// console.log(error);
		yield put(fetchPendingBalanceError(error));
		yield put(showErrorMsg(error.message));
	}
}

function* neuuWalletPayment(action) {
	try {
		const { payload = {} } = action;
		const { sessionId } = yield select((state) => state.auth || {});
		const res = yield call(validateSession, neuuWalletPaymentAPI, { ...payload, cart: payload.order }, sessionId);
		const { order = {} } = res;
		yield put(setPendingOrders([order]));
		yield put(setAllLiveOrders(Object.values(order)));
		yield put(paymentSuccess(res));
		yield put(resetCart());
		deleteCookie('cart');
	} catch (error) {
		// console.log(error);
		yield put(showErrorMsg(error.message));
		yield put(paymentError(error));
	}
}

let lastFetch = false;
function* debouncedFetchPaymentMethods(action) {
	try {
		if (lastFetch) {
			yield cancel(lastFetch);
		}

		lastFetch = yield fork(fetchPaymentMethods, action);
	} catch (error) {
		// console.error(error);
	}
}

function* checkPaymentStatus(action) {
	try {
		const { sessionId } = yield select((state) => state.auth || {});
		const { reqPayload: { paymentMethod, mobile, amount, orderId, txn_id, delivery_fee = 0 } = {} } = action.payload;
		const { saveVpa = true, vpa, name } = paymentMethod;
		let res = null;
		let req = {
			payment_method: name,
			mobile: mobile,
			amount: amount,
			orderId,
			deviceType: process.env.REACT_APP_DEVICE_TYPE || '',
			txn_id,
			vpa: saveVpa ? vpa : '',
			param: 'd',
			delivery_fee,
		};
		const startTime = Date.now();
		while (true) {
			const { cancelPooling } = yield select((state) => state.payment || {});
			const endTime = Date.now();
			if (cancelPooling || endTime - startTime > 1000 * 60 * 5) {
				throw new Error(
					'Transaction failed.\n Any money deducted will be refunded to your Tiny Mart Wallet within a day.'
				);
			}

			yield delay(2000);
			res = yield call(validateSession, checkPaymentStatusAPI, req, sessionId);
			const { status, retry = false } = res;
			if (!retry) {
				if (!status) {
					throw new Error(
						'Transaction failed.\n Any money deducted will be refunded to your Tiny Mart Wallet within a day.'
					);
				}
				break;
			}
		}

		const { order = {} } = res;
		yield put(setPendingOrders([order]));
		yield put(paymentSuccess(res));
		yield put(setAllLiveOrders(Object.values(order)));
		yield put(resetCart());
		deleteCookie('cart');
	} catch (error) {
		yield put(showErrorMsg(error.message, 20000));
		yield put(paymentError(error));
	}
}

function* upiCollect(action) {
	try {
		const { sessionId } = yield select((state) => state.auth || {});
		const { paymentMethod, imei = '' } = action.payload;
		const { vpa } = paymentMethod;
		const res = yield call(validateSession, validateVpaAPI, vpa, imei, sessionId);
		const { status } = res;
		if (!status) {
			return yield put(setSelectedPaymentError(new Error('Invalid VPA')));
		}

		yield all([put(resetVerification()), put(makePaymentAction(action.payload))]);
	} catch (error) {
		// console.log(error);
		yield put(showErrorMsg(error.message, 20000));
		yield put(paymentError(error));
	}
}

function* clearVpa(action) {
	try {
		const { sessionId } = yield select((state) => state.auth || {});
		const { paymentMethod, mobile } = action.payload;
		const { id } = paymentMethod;
		yield call(validateSession, clearVpaAPI, mobile, id, sessionId);
		yield put(clearVpaSuccess({ ...paymentMethod, vpa: '' }));
		firebase.analytics().logEvent('upi_id_cleared');
	} catch (error) {
		// console.log(error);
		yield put(showErrorMsg(error.message));
		yield put(clearVpaError(error));
	}
}

function* pgAddMoney(action) {
	try {
		const { sessionId } = yield select((state) => state.auth || {});
		const { paymentMethod } = action.payload;
		if (!paymentMethod.data) {
			throw new Error('Error while processing payment');
		}

		if (paymentMethod.id === 'Ola') {
			yield call(validateSession, pgAddMoneyAPI, action.payload, sessionId);
		}
		return processPaytmAddMoney(paymentMethod.data);
	} catch (error) {
		yield put(showErrorMsg(error.message, 20000));
		const { param = '' } = action.payload;
		if (param === 'w') {
			yield put(loadWalletError(error)); // for wallet pg load error scenarios
		} else {
			yield put(paymentError(error));
		}
	}
}

export function* watchPayment() {
	yield takeLatest(FETCH_PAYMENT_METHODS, fetchPaymentMethods);
	yield takeEvery(LINK_PAYMENT_SEND_OTP, linkPaymentSendOTP);
	yield takeEvery(LINK_PAYMENT_METHOD, linkPaymentMethod);
	yield takeLatest(MAKE_PAYMENT, makePayment);
	yield takeLatest(CAPTURE_PAYMENT, capturePayment);
	yield takeLatest(FETCH_PENDING_BALANCE, fetchPendingBalance);
	yield takeLatest(NEUU_WALLET_MAKE_PAYMENT, neuuWalletPayment);
	yield debounce(400, DEBOUNCE_FETCH_PAYMENT_METHODS, debouncedFetchPaymentMethods);
	yield takeLatest(POOL_PAYMENT_STATUS, checkPaymentStatus);
	yield takeLatest(UPI_COLLECT_PAYMENT, upiCollect);
	yield takeLatest(CLEAR_UPI_VPA, clearVpa);
	yield takeLatest(ADD_MONEY_PG, pgAddMoney);
}
